import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SectionBannerInput, SectionBannerPage, SectionBannerRecord, SectionBannersService } from './section-banners.service';

@Injectable({ providedIn: 'root' })
export class RefurbishedSettingsService extends SectionBannersService {
  constructor(http: HttpClient, @Inject('API_URL') url: string, @Inject('API_VERSION') version: string) {
    super(http, url, version, { routePrefix: 'refurbish', featureEntity: 'refurbished', orderKey: 'refurbished_banners', label: 'Used Tech' });
  }

  getCategoryBanners() {
    return this.request<SectionBannerPage>('GET', 'refurbish/category-banners/admin/list');
  }

  saveCategoryBanner(input: SectionBannerInput, id: number | null) {
    return this.request<SectionBannerRecord>(id === null ? 'POST' : 'PUT', `refurbish/category-banners${id === null ? '' : `/${id}`}`, input);
  }

  deleteCategoryBanner(id: number) {
    return this.request('DELETE', `refurbish/category-banners/${id}`);
  }

  reorderCategoryBanners(banners: { id: number; position: number }[]) {
    return this.request('PUT', 'refurbish/category-banners/positions/align', { banners });
  }
}
